"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { BiLogoDribbble, BiLogoLinkedinSquare } from "react-icons/bi";
import { FaXTwitter } from "react-icons/fa6";

export function Team7() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="mb-12 max-w-lg md:mb-18 lg:mb-20">
          <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
            Our Team
          </h2>
          <p className="md:text-md">
            Meet the passionate individuals behind our mission.
          </p>
        </div>
        <div className="grid grid-cols-1 items-start justify-center gap-x-8 gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          <div className="flex flex-col items-start">
            <div className="mb-5 md:mb-6">
              <img
                src="./media/alisha.jpeg"
                alt="Relume placeholder image 1"
                className="size-20 min-h-20 min-w-20 rounded-full object-cover"
              />
            </div>
            <div className="mb-3 md:mb-4">
              <h5 className="text-md font-semibold md:text-lg">
                Alisha
              </h5>
              <h6 className="md:text-md">Volunteer</h6>
            </div>
            <p>Recruiting and managing our dedicated volunteers for maximum
            impact.</p>
            <div className="mt-6 flex gap-3.5">
              <a target="_blank" href="https://www.instagram.com/kiva_care_foundation/">
                <BiLogoLinkedinSquare className="size-6" />
              </a>
             
            </div>
          </div>
          <div className="flex flex-col items-start">
            <div className="mb-5 md:mb-6">
              <img
                src="./media/ishank.jpeg"
                alt="Relume placeholder image 1"
                className="size-20 min-h-20 min-w-20 rounded-full object-cover"
              />
            </div>
            <div className="mb-3 md:mb-4">
              <h5 className="text-md font-semibold md:text-lg">Ishank Goel</h5>
              <h6 className="md:text-md">Tech Coordinator</h6>
            </div>
            <p>Passionate about finding loving homes for abandoned animals.</p>
            <div className="mt-6 flex gap-3.5">
              <a target="_blank" href="https://www.instagram.com/ishank_811/">
                <BiLogoLinkedinSquare className="size-6" />
              </a>
              
            </div>
          </div>
          <div className="flex flex-col items-start">
            <div className="mb-5 md:mb-6">
              <img
                src="./media/amit.jpeg"
                alt="Relume placeholder image 1"
                className="size-20 min-h-20 min-w-20 rounded-full object-cover"
              />
            </div>
            <div className="mb-3 md:mb-4">
              <h5 className="text-md font-semibold md:text-lg">Amit</h5>
              <h6 className="md:text-md">Social media manager</h6>
            </div>
            <p>Sharing our story and engaging the community online.</p>
           
            <div className="mt-6 flex gap-3.5">
              <a target="_blank" href="https://www.instagram.com/shishodia.amit___">
                <BiLogoLinkedinSquare className="size-6" />
              </a>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <div className="mb-5 md:mb-6">
              <img
                src="./media/rahul.jpeg"
                alt="Relume placeholder image 1"
                className="size-20 min-h-20 min-w-20 rounded-full object-cover"
              />
            </div>
            <div className="mb-3 md:mb-4">
              <h5 className="text-md font-semibold md:text-lg">Rahul</h5>
              <h6 className="md:text-md">Fundraising Lead</h6>
            </div>
            <p>Ensuring we have the resources to support our mission.</p>
            <div className="mt-6 flex gap-3.5">
              <a target="_blank" href="https://www.instagram.com/rahul_09.09/">
                <BiLogoLinkedinSquare className="size-6" />
              </a>
             
            </div>
          </div>
          <div className="flex flex-col items-start">
            <div className="mb-5 md:mb-6">
              <img
                src="./media/humesh.jpeg"
                alt="Relume placeholder image 1"
                className="size-20 min-h-20 min-w-20 rounded-full object-cover"
              />
            </div>
            <div className="mb-3 md:mb-4">
              <h5 className="text-md font-semibold md:text-lg">Humesh</h5>
              <h6 className="md:text-md">Legal Advisor</h6>
            </div>
            <p>Dedicated to providing the best care for our furry friends.</p>
            <div className="mt-6 flex gap-3.5">
              <a target="_blank" href="https://www.instagram.com/ghai_humesh/">
                <BiLogoLinkedinSquare className="size-6" />
              </a>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <div className="mb-5 md:mb-6">
              <img
                src="./media/shivani.jpeg"
                alt="Relume placeholder image 1"
                className="size-20 min-h-20 min-w-20 rounded-full object-cover"
              />
            </div>
            <div className="mb-3 md:mb-4">
              <h5 className="text-md font-semibold md:text-lg">Shivani</h5>
              <h6 className="md:text-md">Volunteer</h6>
            </div>
            <p>
              Connecting people with opportunities to help our furry friends.
            </p>
            <div className="mt-6 flex gap-3.5">
              <a target="_blank" href="https://www.instagram.com/shivanisingh1677/">
                <BiLogoLinkedinSquare className="size-6" />
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
